<template>
  <k-page class="page-promos">
    <div class="page-promos__controls">
      <el-tooltip content="Обновить данные" placement="top">
        <el-button @click="handleRefresh()" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isPromosLoading"></el-button>
      </el-tooltip>

      <el-tooltip content="Добавить акцию" placement="top">
        <el-button @click="handleAdd()" type="success" icon="el-icon-plus" circle size="mini"></el-button>
      </el-tooltip>
    </div>

    <div class="page-promos__filter">
      <el-radio v-model="actionsFilter" label="all">Все акции</el-radio>
      <el-radio v-model="actionsFilter" label="active">Действующие акции</el-radio>
    </div>

    <k-promos-list
      :promos="promos"
      @edit="setPromo"
      @delete="deletePromo"
    />
    <k-promo-edit-form
      :dialogFormVisible="activePromo !== '' || creatigNew"
      :promo="promo"
      @cancel="handleCancel"
    />
  </k-page>
</template>

<script>
/**
 * Page: Страница редактирования акций
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';


// Components
import KPage from '@/components/KPage.vue';
import KPromoEditForm from '@/components/KPromoEditForm.vue';
import KPromosList from '@/components/KPromosList.vue';


export default {
  name: 'page-promos',

  data() {
    return {
      activePromo: '',
      creatigNew: false,
      actionsFilter: 'active',
    };
  },

  computed: {
    promo() {
      const promo = this.promos.find(item => item._id === this.activePromo);

      return this.creatigNew || !promo
        ? {}
        : promo;
    },

    promos() {
      return this.actionsFilter === 'all'
        ? this.allPromos
        : this.activePromos;
    },

    ...mapGetters({
      isPromosLoading: 'promos/isPromosLoading',
      allPromos: 'promos/promos',
      activePromos: 'promos/activePromos',
    }),
  },

  async created() {
    await this.getPromos();
  },

  methods: {
    setPromo(id) {
      this.activePromo = id;
    },

    handleCancel() {
      this.creatigNew = false;
      this.activePromo = '';
    },

    async deletePromo(id) {
      console.log('deletePromo');
      await this.deletePromo(id);
    },

    // Обновление данных с бекенда
    async handleRefresh() {
      await this.getPromos();
    },

    // Добавление акции
    handleAdd() {
      this.creatigNew = true;
    },

    ...mapActions({
      deletePromo: 'promos/deletePromo',
      getPromos: 'promos/getPromos',
    }),
  },

  components: {
    KPage,
    KPromoEditForm,
    KPromosList,
  },
};
</script>

<style lang="scss">
  .page-promos {
    display: flex;
    flex-direction: column;

    &__controls {
      margin-bottom: 24px;
    }

    &__filter {
      margin-bottom: 24px;
    }
  }
</style>
